















import Vue from "vue";
import TheLogin from "@/components/TheLogin.vue";

export default Vue.extend({
  name: "TheUserInfo",
  components: { TheLogin },
  data: () => {
    return {
      loading: false,
      menuOpen: false,
      error: "",
    };
  },
  computed: {
    userLabel(): string {
      return this.$user
        ? this.$user.user_metadata?.full_name || this.$user.email
        : "Login";
    },
  },
  methods: {
    resetError() {
      this.error = "";
    },
    async logout() {
      this.loading = true;
      try {
        await this.$user?.logout();
        this.$user = null;
        this.menuOpen = false;
      } catch (error) {
        console.error(error);
        this.error = `Logout failed: ${error.json?.error_description || error}`;
      } finally {
        this.loading = false;
      }
    },
    async loginUser(userInfo: any) {
      this.loading = true;
      try {
        const user = await this.$auth.login(
          userInfo.email,
          userInfo.password,
          true
        );
        console.log(user);
        this.$user = user;
        this.menuOpen = false;
      } catch (error) {
        console.error(error);
        this.error = `Login failed: ${error.json?.error_description || error}`;
      } finally {
        this.loading = false;
      }
    },
    async registerUser(userInfo: any) {
      this.loading = true;
      const registeredUser = await this.$auth.signup(
        userInfo.email,
        userInfo.password
      );
      console.log(registeredUser);
      this.$user = registeredUser;
      this.menuOpen = false;
      this.loading = false;
    },
  },
});
